<template lang="html">
    <el-tooltip :manual="isPad" effect="dark" v-model="tooltipVisible" :content="basedataGetName('SysTip',tipCode)" placement="top">
        <i class="iconfont icon-tishi1" @click.prevent="showTooltip"></i>
    </el-tooltip>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
  export default {
    props: {
        'tipCode': {
            required: true
        },
    },
    data() {
        return {
            tooltipVisible: false
        }
    },
    computed: {        
        ...mapGetters(['basedataGetName']),
        isPad() {
            const target = this.$getWindowTarget();
            return target === '_self';
        }
    },
    methods: {
        ...mapActions(['initBaseDataByTypes']),
        showTooltip() {
            this.tooltipVisible = true;
            setTimeout(() => {
                this.tooltipVisible = false;
            },3000)
        },
    },
    mounted() {    
        this.initBaseDataByTypes(['SysTip'])
            .then(() => {
            })
    }
  };
</script>
<style lang="less" scoped>
    .iconfont {
        font-size: 14px;
    }
</style>


// WEBPACK FOOTER //
// CommonTooltip.vue?7b9e336a